// Simple line-art SVG icons for services. Match primary stroke colour.
const common = { width: 48, height: 48, viewBox: "0 0 48 48", fill: "none", stroke: "currentColor", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" };

export function IconHybrid(props) {
  return (
    <svg {...common} {...props}>
      <circle cx="16" cy="20" r="7" />
      <circle cx="32" cy="20" r="7" />
      <circle cx="24" cy="33" r="7" />
      <line x1="4" y1="42" x2="44" y2="42" />
    </svg>
  );
}
export function IconMagnifier(props) {
  return (
    <svg {...common} {...props}>
      <circle cx="20" cy="20" r="11" />
      <line x1="28" y1="28" x2="40" y2="40" />
      <path d="M15 20 L19 24 L26 16" />
    </svg>
  );
}
export function IconChart(props) {
  return (
    <svg {...common} {...props}>
      <line x1="6" y1="42" x2="42" y2="42" />
      <line x1="6" y1="42" x2="6" y2="8" />
      <rect x="11" y="28" width="5" height="14" />
      <rect x="20" y="20" width="5" height="22" />
      <rect x="29" y="12" width="5" height="30" />
    </svg>
  );
}
export function IconLeaf(props) {
  return (
    <svg {...common} {...props}>
      <path d="M10 38 C10 20, 28 8, 40 8 C40 22, 28 40, 10 38 Z" />
      <line x1="10" y1="38" x2="28" y2="20" />
      <line x1="24" y1="12" x2="40" y2="8" strokeDasharray="2 3" />
    </svg>
  );
}
export function IconBlock(props) {
  return (
    <svg {...common} {...props}>
      <rect x="6" y="8" width="8" height="8" />
      <rect x="20" y="8" width="8" height="8" />
      <rect x="34" y="8" width="8" height="8" />
      <rect x="6" y="20" width="8" height="8" />
      <rect x="20" y="20" width="8" height="8" fill="currentColor" fillOpacity="0.25" />
      <rect x="34" y="20" width="8" height="8" />
      <rect x="6" y="32" width="8" height="8" />
      <rect x="20" y="32" width="8" height="8" />
      <rect x="34" y="32" width="8" height="8" fill="currentColor" fillOpacity="0.25" />
    </svg>
  );
}
export function IconCheck(props) {
  return (
    <svg {...common} {...props}>
      <circle cx="24" cy="24" r="18" />
      <path d="M14 24 L22 32 L34 16" />
    </svg>
  );
}
export function IconGauge(props) {
  return (
    <svg {...common} {...props}>
      <path d="M6 32 A18 18 0 0 1 42 32" />
      <line x1="24" y1="32" x2="32" y2="18" />
      <circle cx="24" cy="32" r="2" fill="currentColor" />
      <line x1="10" y1="32" x2="13" y2="32" />
      <line x1="38" y1="32" x2="35" y2="32" />
      <line x1="24" y1="14" x2="24" y2="17" />
    </svg>
  );
}
export function IconHardHat(props) {
  return (
    <svg {...common} {...props}>
      <path d="M8 36 L40 36 L40 32 C40 22, 34 16, 24 16 C14 16, 8 22, 8 32 Z" />
      <line x1="20" y1="16" x2="20" y2="8" />
      <line x1="28" y1="16" x2="28" y2="8" />
      <line x1="4" y1="40" x2="44" y2="40" />
    </svg>
  );
}

export function ServiceIcon({ name, ...rest }) {
  const map = {
    hybrid: IconHybrid,
    magnifier: IconMagnifier,
    chart: IconChart,
    leaf: IconLeaf,
    block: IconBlock,
    check: IconCheck,
    gauge: IconGauge,
    "hard-hat": IconHardHat,
  };
  const C = map[name] || IconCheck;
  return <C {...rest} />;
}
